import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetBadgeCountResponseDto } from "../../dtos/get-badge-count-response-dto";
import { OrderQueryKeys } from "../../generators/order-query-keys";
import { OrderService } from "../../services/order-service";

type UseGetClaimOrderBadgeCountQueryParams = {
  options?: Omit<UseQueryOptions<GetBadgeCountResponseDto>, "queryKey">;
};

export const useGetClaimOrderBadgeCountQuery = ({
  options
}: UseGetClaimOrderBadgeCountQueryParams = {}) => {
  return useQuery({
    queryKey: OrderQueryKeys.getClaimOrderBadgeCount().queryKey,
    queryFn: async () => await OrderService.getClaimOrderBadgeCount(),
    ...options
  });
};
